<template>
  <van-icon name="arrow"/>
</template>

<script>
import {Icon} from "vant";

export default {
  name: "VgArrowIcon",
  components: {'van-icon': Icon}
}
</script>

<style scoped>
.van-icon-arrow:before {
  color: #C8C8C8;
  font-size: 20px;
}
</style>